export default __webpack_public_path__ + "static/media/about-product.84b1238d.svg";